import { render, staticRenderFns } from "./ArenaScore.vue?vue&type=template&id=0fbecbf4&scoped=true&"
import script from "./ArenaScore.vue?vue&type=script&lang=js&"
export * from "./ArenaScore.vue?vue&type=script&lang=js&"
import style0 from "./ArenaScore.vue?vue&type=style&index=0&id=0fbecbf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbecbf4",
  null
  
)

export default component.exports